export function extractResources(response) {
  const rawEntries = [
    response?.data?.resources,
    response?.resources,
    response?.events,
    Array.isArray(response) ? response : null,
  ].find((possibleEntries) => Array.isArray(possibleEntries));

  if (!rawEntries) {
    if (response?.totalRecordsMatched === 0) return [];
    return [];
  }

  return rawEntries.map((entry, index) => {
    const baseKey =
      entry?.uuid ||
      entry?.debugContext?.debugData?.dtHash ||
      entry?.transaction?.id ||
      `${entry?.published || 'na'}|${entry?.eventType || 'na'}`;

    return {
      rowKey: `${baseKey}|${index}`,
      position: index + 1,
      uuid: entry?.uuid,
      displayMessage: entry?.displayMessage,
      severity: entry?.severity,
      published: entry?.published,
      outcome: {
        result: entry?.outcome?.result,
        reason: entry?.outcome?.reason,
      },
      eventType: entry?.eventType,
    };
  });
}
